import React, { useMemo } from 'react';
import styles from './Digit.module.scss';

interface DigitProps {
    animated: boolean;
    currentNumber: number;
    charSrc?: string;
    inclusions: (Intl.NumberFormatPart & {
        position: 'right' | 'left';
    })[];
}

const Digit: React.FC<DigitProps> = ({ currentNumber, charSrc = 'animations/progressive-jackpot/img/fonts/jackpot', animated, inclusions }) => {
    const digitStripOffset = useMemo(() => {
        let lastDigit = -Infinity;
        // guard against doing an anim if digit stays the same
        if (currentNumber === lastDigit) return;

        const steps = 10;
        const percentPerStep = 360 / steps;
        const offset = (currentNumber + 1) * percentPerStep;
        const transform = `rotateX(${-offset}deg)`;

        lastDigit = currentNumber;
        return { transform };
    }, [currentNumber]);

    const resolveDigitSrcSet = (num: number) => {
        return `
            ${charSrc}/1x/char_${num}.png 1x,
            ${charSrc}/2x/char_${num}@2x.png 2x,
            ${charSrc}/3x/char_${num}@3x.png 3x
        `;
    };

    const resolveInclusionSrcSet = (type: string) => {
        return `
            ${charSrc}/1x/char_${type}_isolated.png 1x,
            ${charSrc}/2x/char_${type}_isolated@2x.png 2x,
            ${charSrc}/3x/char_${type}_isolated@3x.png 3x
        `;
    };
    return (
        <>
            <div className={styles.keyhole}>
                {inclusions.map((chunk) => (
                    <img
                        key={chunk.type + chunk.value + chunk.position}
                        className={`${styles.inclusion}${' ' + styles[chunk.position]}${' ' + styles[chunk.type]} counter-inclusion`}
                        width='20'
                        height='20'
                        src={`${charSrc}/1x/char_${chunk.type}_isolated.png`}
                        srcSet={resolveInclusionSrcSet(chunk.type)}
                    />
                ))}
                <div className={styles['number-spacer']}>
                    <img width='48' height='64' src={`${charSrc}/1x/char_literal.png`} />
                </div>
                <div className={`${styles.strip} ${animated ? styles.animated : ''}`} style={digitStripOffset}>
                    {Array.from({ length: 10 }).map((_, index) =>
                        charSrc ? (
                            <img
                                width='38'
                                height='70'
                                key={index}
                                className={`${styles.number} counter-number`}
                                src={`${charSrc}/1x/char_${index}.png`}
                                srcSet={resolveDigitSrcSet(index)}
                                alt={currentNumber === index ? `${index}` : ''}
                            />
                        ) : (
                            <div key={index} className={styles.number}>
                                {index}
                            </div>
                        )
                    )}
                </div>
            </div>
        </>
    );
};

export default Digit;
